import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles(theme => ({
  tag: {
    width: '5em',
    height: '2em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.secondary.main,
  },
}));

const Tag = ({ text }) => {
  const classes = useStyle();
  return <div className={classes.tag}>{text}</div>;
};

export default Tag;
